import { setStats } from '../../actions/statsSection';
import { getAllModulesInitActions } from './common';

export function getStatsSectionInitActions(responseData, requestParams) {
  return [
    setStats(responseData.sectionData),
    ...getAllModulesInitActions(responseData, requestParams),
  ];
}
